export const COMBINED_SEND_LABEL = 'Email Combined Payment Request & Reports'
export const COMBINED_READY_LABEL = 'Combined payment link ready — customer not contacted'

export function combinedPaymentServiceLabel(summary, fallback = 'Workshop service') {
  const cleaned = String(summary || '')
    .replace(/\s*(?:[-–—|·]\s*)?(?:GBP\s*|£)\s*\d+(?:[.,]\d{2})?/gi, ' ')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s*[,;|·-]+\s*|\s*[,;|·-]+\s*$/g, '')
    .trim()
  return cleaned || fallback
}

export function groupBundleCandidates(jobs, workshopId) {
  const groups = new Map()
  jobs.filter(job => job.workshop_id === workshopId && job.customer_id).forEach(job => {
    if (!groups.has(job.customer_id)) groups.set(job.customer_id, [])
    groups.get(job.customer_id).push(job)
  })
  return [...groups].map(([customerId, items]) => ({ customerId, items }))
}

export function partitionBundleCandidates(jobs, workshopId, customerCanReceive = () => true) {
  const available = []
  const unavailable = []

  groupBundleCandidates(jobs, workshopId).forEach(group => {
    const eligible = group.items.filter(item => item.eligible)
    const canReceive = customerCanReceive(group.customerId)
    if (eligible.length >= 2 && canReceive) {
      available.push({ ...group, items: eligible })
      const blocked = group.items.filter(item => !item.eligible)
      if (blocked.length) unavailable.push({ ...group, items: blocked })
      return
    }

    unavailable.push({
      ...group,
      items: group.items.map(item => ({
        ...item,
        issue: item.issue || (!canReceive
          ? 'Customer needs a valid email address'
          : 'At least two eligible jobs are required'),
      })),
    })
  })

  return { available, unavailable }
}

export function toggleBundleSelection(selected, job, workshopId) {
  if (selected.some(item => item.id === job.id)) return selected.filter(item => item.id !== job.id)
  if (!job.eligible || job.workshop_id !== workshopId || selected.length >= 10
    || selected.some(item => item.customer_id !== job.customer_id || item.workshop_id !== job.workshop_id || item.currency !== job.currency)) return selected
  return [...selected, job]
}

export function bundleSelectionTotal(items) {
  return items.reduce((sum, item) => sum + Number(item.amount_pence || 0), 0)
}
